import { Tooltip as T } from 'radix-ui';
import type { ReactElement, ReactNode } from 'react';
import s from './Tooltip.module.css';

export const TooltipProvider = T.Provider;

export function Tooltip({
  content,
  children,
  side = 'top',
  delay,
}: {
  content: ReactNode;
  children: ReactElement;
  side?: 'top' | 'right' | 'bottom' | 'left';
  delay?: number;
}) {
  if (content == null || content === '') return children;
  return (
    <T.Root delayDuration={delay}>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content side={side} sideOffset={6} className={s.content} collisionPadding={8}>
          {content}
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
